{
  "clear": "Vymazať",
  "invalid": "(neplatné)",
  "loading": "Načítava sa...",
  "noResults": "Žiadne výsledky"
}
